let cursorFeatureActive = false;
window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      // console.log("AFTER_PRODUCTS_TRANSFORMED ==>", products);
      products.forEach((product) => {
        product.attributes.forEach((attr) => {
          if (attr.id == "product_badge_judgeme") {
            let divElement = document.createElement("div");
            divElement.innerHTML = attr.values[0].value[0];
            var jdgmPrevBadge = divElement.querySelector(".jdgm-prev-badge");
            var jdgmReviewData = jdgmPrevBadge.getAttribute(
              "data-average-rating"
            );
            var numberOfReviews = jdgmPrevBadge.getAttribute(
              "data-number-of-reviews"
            );
            if (numberOfReviews > 0) {
              product.numberOfReviews = numberOfReviews;
              product.jdgmReviewData = parseFloat(jdgmReviewData).toFixed(1);
            }
          }
          if (attr.id == "product_variant_prices") {
            
            if (attr.values.length > 1) {
              product.hasVariant = true;
            }
          }
        })
      })
      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      // console.log("AFTER_PRODUCTS_TRANSFORMED ==>", products);
      let searchDrawer = document.querySelector("#SearchDrawer");
      if (searchDrawer) {
          searchDrawer.removeAttribute("open");
          searchDrawer.removeAttribute("active");
      }
      let headerSection = document.querySelector(".shopify-section.shopify-section-group-header-group.header-section.header-sticky");
      if (headerSection) {
        headerSection.classList.remove("header-transparent");
      }
      data.attributeFacetValuesLimit = 50;
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      data.attributeFacetValuesLimit = 50;
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      // console.log("BEFORE_RENDER_RESULTS data : ",data);
      if (data.api === "search" || data.api === "filter") { 
        var facets = data.response.payload.facets;
        for (let i = 0; i < facets.length; i++) {
          if (facets[i].key !== "sellingPrice") {
              let data = facets[i].data;
              data.sort((a, b) => a.key.localeCompare(b.key));
              facets[i].data = data;
          }
        }
      }
      return data;
    }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      document
        .querySelector(".wizzy-filter-button")
        .addEventListener("click", function () {
          var closeButton = document.querySelector(".wizzy-filters-close-btn");
          if (closeButton) {
            closeButton.click();
          }
        });
      let sortClose = document.querySelector(
        ".wizzy-common-select-options.sort-close"
      );
      if (sortClose) {
        sortClose.addEventListener("click", function () {
          if (window.innerWidth > 768) {
            document
              .querySelectorAll(
                ".wizzy-common-select-options.sort-close, .wizzy-common-select-options.sort-close-border"
              )
              .forEach((el) => {
                el.style.display = "none";
              });
          }
        });
        document
        .querySelector(
          ".wizzy-search-filters-drawer-button .button.button--secondary.icon-with-text.wizzy-filters-desktop-entry"
        )
        .addEventListener("click", () => {
          cursorFeatureActive = !cursorFeatureActive;
        });

      document
        .querySelectorAll(
          ".wizzy-search-filters-left-wrapper, .wizzy-filters-header, .wizzy-filters-close-btn"
        )
        .forEach((el) => {
          el.addEventListener("mouseenter", () => {
            if (cursorFeatureActive) {
              document
                .querySelector(".mouse-cursor")
                .classList.remove("active");
              document.body.style.cursor = "default";
            }
          });

          el.addEventListener("mouseleave", () => {
            if (cursorFeatureActive) {
              document.querySelector(".mouse-cursor").classList.add("active");
              document.body.style.cursor = "none";
            }
          });
        });

      document.addEventListener("mouseout", (event) => {
        if (cursorFeatureActive && !event.relatedTarget) {
          document.querySelector(".mouse-cursor").classList.remove("active");
        }
      });

      document.addEventListener("mouseover", (event) => {
        if (cursorFeatureActive && !event.relatedTarget) {
          document.querySelector(".mouse-cursor").classList.add("active");
        }
      });

      document
        .querySelectorAll(".wizzy-filters-bg, .wizzy-filters-close-btn")
        .forEach((el) => {
          el.addEventListener("click", () => {
            cursorFeatureActive = false;
            document.querySelector(".mouse-cursor").classList.remove("active");
            document.body.style.cursor = "default";
          });
        });
        gridFiltersToggleOnOverflow();
      if (window.innerWidth < 768) {
        
        var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

      if (sourceElement) {
        var clonedContent = sourceElement.cloneNode(true);

        var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");
        if (window.innerWidth < 768) {
          if (
            targetDiv &&
            !targetDiv.querySelector(".wizzy-search-sort-wrapper")
          ) {
            targetDiv.appendChild(clonedContent);
          }
        } else {
          if (targetDiv) {
            var clonedSort = targetDiv.querySelector(
              ".wizzy-search-sort-wrapper"
            );
            if (clonedSort) {
              clonedSort.remove();
            }
          }
        }
      }

      
        const filterHeaderTitle = document.querySelector(
          ".wizzy-search-filters-left .wizzy-filters-header .header-title"
        );
        if (filterHeaderTitle) {
          // console.log("Condition executed");
          filterHeaderTitle.textContent = "Filter and sort";
        }
        var sortInFilter = document.querySelector(
          ".wizzy-search-filters-left-wrapper .wizzy-sort-wrapper-in-filter"
        );

        if (
          sortInFilter &&
          !sortInFilter.classList.contains("click-listener-attached")
        ) {
          sortInFilter.addEventListener("click", function (event) {
            // event.preventDefault();
            // event.stopPropagation();
            var sortOptions = document.querySelectorAll(
              ".wizzy-common-select-options"
            );
            if (sortOptions) {
              if (
                sortOptions[1].style.display === "none" ||
                sortOptions[1].style.display === ""
              ) {
                sortOptions[1].style.display = "grid";
                sortOptions[0].style.display = "none";
              } else {
                sortOptions[1].style.display = "none";
              }
            }
          });
          sortInFilter.classList.add("click-listener-attached");
        }
        var hoverElement = document.querySelector(
          ".wizzy-common-select-container > .wizzy-common-select-selector"
        );

        if (
          hoverElement &&
          !hoverElement.classList.contains("click-listener-attached")
        ) {
          hoverElement.addEventListener("click", function (event) {
            var sortOptions = document.querySelectorAll(
              ".wizzy-common-select-options"
            );

            if (sortOptions.length > 1) {
              if (
                sortOptions[1].style.display === "none" ||
                sortOptions[1].style.display === ""
              ) {
                sortOptions[1].style.display = "grid";
                sortOptions[0].style.display = "none";
              } else {
                sortOptions[1].style.display = "none";
              }
            }
          });

          hoverElement.classList.add("click-listener-attached");
        }
      }
      
      return data;
    }
    });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      let sortClose = document.querySelector(
        ".wizzy-common-select-options.sort-close"
      );
      if (sortClose) {
        sortClose.addEventListener("click", function () {
          if (window.innerWidth > 768) {
            document
              .querySelectorAll(
                ".wizzy-common-select-options.sort-close, .wizzy-common-select-options.sort-close-border"
              )
              .forEach((el) => {
                el.style.display = "none";
              });
          }
        });
        document
        .querySelector(
          ".wizzy-search-filters-drawer-button .button.button--secondary.icon-with-text.wizzy-filters-desktop-entry"
        )
        .addEventListener("click", () => {
          cursorFeatureActive = !cursorFeatureActive;
        });

      document
        .querySelectorAll(
          ".wizzy-search-filters-left-wrapper, .wizzy-filters-header, .wizzy-filters-close-btn"
        )
        .forEach((el) => {
          el.addEventListener("mouseenter", () => {
            if (cursorFeatureActive) {
              document
                .querySelector(".mouse-cursor")
                .classList.remove("active");
              document.body.style.cursor = "default";
            }
          });

          el.addEventListener("mouseleave", () => {
            if (cursorFeatureActive) {
              document.querySelector(".mouse-cursor").classList.add("active");
              document.body.style.cursor = "none";
            }
          });
        });

      document.addEventListener("mouseout", (event) => {
        if (cursorFeatureActive && !event.relatedTarget) {
          document.querySelector(".mouse-cursor").classList.remove("active");
        }
      });

      document.addEventListener("mouseover", (event) => {
        if (cursorFeatureActive && !event.relatedTarget) {
          document.querySelector(".mouse-cursor").classList.add("active");
        }
      });

      document
        .querySelectorAll(".wizzy-filters-bg, .wizzy-filters-close-btn")
        .forEach((el) => {
          el.addEventListener("click", () => {
            cursorFeatureActive = false;
            document.querySelector(".mouse-cursor").classList.remove("active");
            document.body.style.cursor = "default";
          });
        });
        gridFiltersToggleOnOverflow();
      if (window.innerWidth < 768) {
        
        var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

      if (sourceElement) {
        var clonedContent = sourceElement.cloneNode(true);

        var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");
        if (window.innerWidth < 768) {
          if (
            targetDiv &&
            !targetDiv.querySelector(".wizzy-search-sort-wrapper")
          ) {
            targetDiv.appendChild(clonedContent);
          }
        } else {
          if (targetDiv) {
            var clonedSort = targetDiv.querySelector(
              ".wizzy-search-sort-wrapper"
            );
            if (clonedSort) {
              clonedSort.remove();
            }
          }
        }
      }

      
        const filterHeaderTitle = document.querySelector(
          ".wizzy-search-filters-left .wizzy-filters-header .header-title"
        );
        if (filterHeaderTitle) {
          // console.log("Condition executed");
          filterHeaderTitle.textContent = "Filter and sort";
        }
        var sortInFilter = document.querySelector(
          ".wizzy-search-filters-left-wrapper .wizzy-sort-wrapper-in-filter"
        );

        if (
          sortInFilter &&
          !sortInFilter.classList.contains("click-listener-attached")
        ) {
          sortInFilter.addEventListener("click", function (event) {
            // event.preventDefault();
            // event.stopPropagation();
            var sortOptions = document.querySelectorAll(
              ".wizzy-common-select-options"
            );
            if (sortOptions) {
              if (
                sortOptions[1].style.display === "none" ||
                sortOptions[1].style.display === ""
              ) {
                sortOptions[1].style.display = "grid";
                sortOptions[0].style.display = "none";
              } else {
                sortOptions[1].style.display = "none";
              }
            }
          });
          sortInFilter.classList.add("click-listener-attached");
        }
        var hoverElement = document.querySelector(
          ".wizzy-common-select-container > .wizzy-common-select-selector"
        );

        if (
          hoverElement &&
          !hoverElement.classList.contains("click-listener-attached")
        ) {
          hoverElement.addEventListener("click", function (event) {
            var sortOptions = document.querySelectorAll(
              ".wizzy-common-select-options"
            );

            if (sortOptions.length > 1) {
              if (
                sortOptions[1].style.display === "none" ||
                sortOptions[1].style.display === ""
              ) {
                sortOptions[1].style.display = "grid";
                sortOptions[0].style.display = "none";
              } else {
                sortOptions[1].style.display = "none";
              }
            }
          });

          hoverElement.classList.add("click-listener-attached");
        }
      }
      
      return data;
    }
    });
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
      function (data) {
        const sortCloseDiv = document.querySelector(
          ".wizzy-common-select-container .wizzy-common-select-options.sort-close"
        );
        if (sortCloseDiv) {
          sortCloseDiv.style.display = "none";
        }
        data.filters.attributeFacetValuesLimit = 50;
        return data;
      }
  );
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        // console.log("BEFORE_INIT data : ",data);
        data.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        data.search.configs.pagination.infiniteScrollOffset = {
          desktop: 1000,
          mobile: 2950
        }
        return data;
      }
  );
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
      function (data) {
        // console.log("BEFORE_INIT data : ",data);
        data.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        data.search.configs.pagination.infiniteScrollOffset = {
          desktop: 1000,
          mobile: 2950
        }
        return data;
      }
  );
  
};

function gridFiltersToggleOnOverflow() {
  // if (window.innerWidth > 768) {
  //   const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

  //   if (filterBoxes.length > 0) {
  //     filterBoxes.forEach((box) => {
  //       const filterList = box.querySelector(
  //         ".wizzy-facet-body .wizzy-facet-list"
  //       );
  //       const toggleBtn = box.querySelector(
  //         ".wizzy-facet-body .wizzy-toggle-btn"
  //       );
  //       const filterOptions = box.querySelector(".wizzy-facet-body");

  //       if (
  //         filterList &&
  //         toggleBtn &&
  //         filterOptions &&
  //         !toggleBtn.classList.contains("wizzy-click-event-attached")
  //       ) {
  //         const filterHeight = filterList.offsetHeight;
  //         const lineHeight = parseFloat(
  //           getComputedStyle(filterList).lineHeight
  //         );
  //         console.log("lineHeight : ",lineHeight);
  //         console.log("filterHeight : ",filterHeight);
  //         const maxVisibleLines = 2;
  //         const visibleLines = (Math.floor(filterHeight / lineHeight) - 1)/2;
  //         console.log("Visble lines : ",visibleLines);
  //         if (visibleLines > maxVisibleLines) {
  //           filterOptions.classList.add("collapsed");
  //           toggleBtn.classList.add("wizzy-click-event-attached");
  //           toggleBtn.style.display = "inline-block";
  //         } else {
  //           toggleBtn.style.display = "none";
  //         }

  //         toggleBtn.addEventListener("click", function () {
  //           if (filterOptions.classList.contains("collapsed")) {
  //             filterOptions.classList.remove("collapsed");
  //             filterOptions.classList.add("expanded");
  //             toggleBtn.innerText = "- Less";
  //           } else {
  //             filterOptions.classList.remove("expanded");
  //             filterOptions.classList.add("collapsed");
  //             toggleBtn.innerText = "+ More";
  //           }
  //           toggleBtn.classList.add("wizzy-click-event-attached");
  //         });
  //       }
  //     });
  //   }
  // }
 if (window.innerWidth > 768) {
  const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

  filterBoxes.forEach((box) => {
    const filterList = box.querySelector(".wizzy-facet-body .wizzy-facet-list");
    const toggleBtn = box.querySelector(".wizzy-facet-body .wizzy-toggle-btn");
    const filterOptions = box.querySelector(".wizzy-facet-body");

    if (
      filterList &&
      toggleBtn &&
      filterOptions &&
      !toggleBtn.classList.contains("wizzy-click-event-attached")
    ) {
      const allItems = Array.from(filterList.children);

      // Show all if 5 or fewer items
      if (allItems.length <= 5) {
        allItems.forEach((el) => {
          el.style.display = "";
        });
        toggleBtn.style.display = "none"; // hide toggle
      } else {
        // Proceed with collapse logic
        const firstFive = allItems.slice(0, 5);
        const firstLineTop = firstFive[0].offsetTop;
        let lineCount = 1;

        for (let i = 1; i < firstFive.length; i++) {
          if (firstFive[i].offsetTop > firstLineTop) {
            lineCount++;
          }
        }

        const maxLines = 2;
        const collapseToTwoLines = lineCount > maxLines;

        if (collapseToTwoLines) {
          // Collapse to 2 lines based on height
          filterList.style.maxHeight = `${filterList.offsetHeight}px`; // Let it render first
          requestAnimationFrame(() => {
            filterList.style.maxHeight = `${getLineHeight(filterList) * 2}px`;
            filterList.style.overflow = "hidden";
          });
          filterOptions.classList.add("collapsed");
        } else {
          // Show only first 5 items
          allItems.forEach((el, index) => {
            el.style.display = index < 5 ? "" : "none";
          });
          filterOptions.classList.add("collapsed");
        }

        // Show toggle
        toggleBtn.style.display = "inline-block";
        toggleBtn.classList.add("wizzy-click-event-attached");

        toggleBtn.addEventListener("click", function () {
          const isCollapsed = filterOptions.classList.contains("collapsed");

          if (isCollapsed) {
            filterOptions.classList.remove("collapsed");
            filterOptions.classList.add("expanded");
            toggleBtn.innerText = "- Less";

            // Show all
            filterList.style.maxHeight = "";
            filterList.style.overflow = "";
            allItems.forEach((el) => {
              el.style.display = "";
            });
          } else {
            filterOptions.classList.remove("expanded");
            filterOptions.classList.add("collapsed");
            toggleBtn.innerText = "+ More";

            if (collapseToTwoLines) {
              filterList.style.maxHeight = `${getLineHeight(filterList) * 2}px`;
              filterList.style.overflow = "hidden";
            } else {
              allItems.forEach((el, index) => {
                el.style.display = index < 5 ? "" : "none";
              });
            }
          }
        });
      }
    }
  });

  function getLineHeight(element) {
    return parseFloat(getComputedStyle(element).lineHeight);
  }
}





}
